define('editor/edit/map/controls/minimap',['durandal/app', 'jquery', 'knockout', '../configHelpers', 'leaflet-minimap'], function (app, $, ko, configHelper) {
    var control = function (options) {
        var self = this;

        self.options = options;
        self.layer = options.layer;

        if (!Object.keys(self.layer.state()).length) {
            self.layer.state({
                width: ko.observable(150), // defaults
                height: ko.observable(150),
                zoom: ko.observable(5),
                position: {
                    x: ko.observable(-75),
                    y: ko.observable(-75)
                }
            });
        }

        self.addToMap = function () {
            // use the our custom map pane as a container to attach the control to
            var controlContainer = self.options.mapControl._controlContainer,
                tileLayer = configHelper.mapEditorMapConfigToLeafletTilelayerProps(self.options.editorMap, self.options.editorMap.tileLayers[0]),
                labelsLayer = configHelper.mapEditorMapConfigToLeafletTilelayerProps(self.options.editorMap, self.options.editorMap.labelsLayer),
                opts = {
                    layer: tileLayer,
                    labelsLayer: labelsLayer,
                    container: controlContainer,
                    viewport: {
                        height: self.options.editorMap.height,
                        width: self.options.editorMap.width
                    },
                    drawMarker: true,
                    pane: controlContainer,
                };

            $.extend(opts, ko.toJS(self.layer.state()));

            // create the control
            self.control = L.draggableMinimap(opts);

            if (self.layer.visible()) {
                self.show();
            }
            self.registerEventHandlers();
        };

        self.registerEventHandlers = function () {
            self.options.mapControl.on("miniMapMoved", self.handleMiniMapMoved);
            self.options.mapControl.on("miniMapZoomChange", self.handleMiniMapZoomChange);
        };

        self.deregisterEventHandlers = function () {
            self.options.mapControl.off("miniMapMoved", self.handleMiniMapMoved);
            self.options.mapControl.off("miniMapZoomChange", self.handleMiniMapZoomChange);
        };

        self.allowEdit = function () {
            if (self.layer.visible()) {
                self.control.enableEdit();
            }
        };

        self.preventEdit = function () {
            if (self.layer.visible()) {
                self.control.disableEdit();
            }
        };

        self.hide = function () {
            self.control.remove();
            self.deregisterEventHandlers();
        };

        self.show = function () {
            self.control.addTo(self.options.mapControl);
            self.control._container.style.zIndex = 1000 - self.layer.order();
        };

        self.remove = function () {
            self.hide();
            self.deregisterEventHandlers();
        };

        // events
        self.handleMiniMapMoved = function (e) {
            self.layer.state().position = {
                x: ko.observable(e.x),
                y: ko.observable(e.y)
            };
        };

        self.handleMiniMapZoomChange = function (e) {
            self.layer.state().zoom(e.zoom);
        };
    };

    return control;
});

